import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   useColorMode,
   IconButton,
} from '@chakra-ui/react';
import dotIcon from '../../../../assets/img/nfts/dot.svg';
import { MdDeleteOutline, MdOutlineEdit } from 'react-icons/md';
import AddEditForm from '../Pages/CustomerMaster/AddEditForm';
import ItemMasterForm from '../Pages/ItemMaster/ItemMasterForm';
import AddEditFormForAccount from '../Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../Pages/DaybookMaster/DaybookForm';
import DeleteDialog from '../components/DeleteDialog';
import { deleteVendor } from '../../../../redux/actions/vendor';
import { deleteCustomer, getAccount } from '../../../../redux/actions/account';
import { deleteItem } from '../../../../redux/actions/item';
import { deleteDaybook, getDaybookForPayments } from '../../../../redux/actions/daybook';
import { useDispatch, useSelector } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import { formatAmountWithLabel } from 'utils/util';
import { getInventoryDetailReport, getReportSerialWiseHistory } from '../../../../redux/actions/reports';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import { deleteSaleInvoice, getSingleWithPrevAndNext } from '../../../../redux/actions/salesInvoice';
import { getSinglePurchaseWithPrevAndNext, deletePurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getAccountById } from '../../../../redux/actions/account';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteRecord } from 'utils/util';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import JournalVoucherForm from 'views/admin/journal-vouchers/Pages/JournalVoucherForm';
import { getJournalVoucher } from '../../../../redux/actions/journalVoucher';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import moment from 'moment';
import { FiRefreshCcw } from 'react-icons/fi';
import { getStock } from '../../../../redux/actions/salesLineDetail';

const ViewSingleData = ({
   isOpenSingleView,
   onClose,
   entityType,
   singleEntity,
   dynamicArray,
   ItemId,
   onDelete,
   formType,
   parentGlGroup,
   singleEntityRights,
   reCall,
}) => {
   const [activeTab, setActiveTab] = useState(
      entityType === 'customer' || entityType === 'vendor' || entityType === 'Account' ? 'payment' : 'stock',
   );
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [selectedRowId, setSelectedRowId] = useState(null);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const [data, setData] = useState([]);
   const [stockData, setStockData] = useState([]);
   const businessType = localStorage.getItem('businessTypes');
   const isCustomersOrVendors = entityType === 'customer' || entityType === 'vendor' || entityType === 'Account';
   const IsItem = entityType === 'Item';
   const dispatch = useDispatch();
   const { user } = useUser();
   const Admin = user?.isAdmin;
   const [entityTypesv, setEntityTypesv] = useState([]);
   const singleEntitysv = useSelector((state) => {
      if (entityTypesv === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityTypesv === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else if (entityTypesv === 'cash') {
         return state.voucher?.single || {};
      } else if (entityTypesv === 'bank') {
         return state.voucher?.single || {};
      } else {
         return {};
      }
   });
   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),

      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),

      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

      docNumber: Yup.string().required('Document number is required'),

      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),

      txnType: Yup.number().required('Transaction type is required'),
   });
   const accountData = useSelector((state) => state.account.list);
   const { company, userGlobalSettingsData } = useGlobal();
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendIdInAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [sortConfig, setSortConfig] = useState({
      key: 'created_at',
      direction: 'desc',
   });
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [sorting, setSorting] = useState([]);
   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      outAdjustments: [],
   });
   const companyId = Number(localStorage.getItem('companyId'));
   const cashRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cash
      : null;
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isRotating, setIsRotating] = useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [isOpenJV, setisOpenJV] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.salesData);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.purchaseData);
   const viewDataissue = useSelector((state) => state?.issueInventory?.single);
   const viewDatareceive = useSelector((state) => state.receiveInventory?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityTypesv === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityTypesv === 'salereturn'
               ? viewDatasr?.data[0]
               : entityTypesv === 'saleinvoice'
                  ? viewDatasi?.data[0]
                  : entityTypesv === 'purchaseinvoice'
                     ? viewDatapi?.data[0]
                     : entityTypesv === 'receiveinventory'
                        ? viewDatareceive
                        : entityTypesv === 'issueinventory'
                           ? viewDataissue
                           : null;

      const pagination =
         entityTypesv === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityTypesv === 'salereturn'
               ? viewDatasr?.pagination
               : entityTypesv === 'saleinvoice'
                  ? viewDatasi?.pagination
                  : entityTypesv === 'purchaseinvoice'
                     ? viewDatapi?.pagination
                     : entityTypesv === 'receiveinventory'
                        ? viewDatareceive?.pagination
                        : entityTypesv === 'issueinventory'
                           ? viewDataissue?.pagination
                           : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi?.data,
      viewDatasi?.pagination,
      viewDatapi?.data,
      viewDatapi?.pagination,
      viewDatareceive,
      viewDataissue,
   ]);

   useEffect(() => {
      if (isOpenSingleView) {
         if (isCustomersOrVendors) {
            setActiveTab('payment');
         } else if (IsItem) {
            setActiveTab('stock');
         }
      }
   }, [isOpenSingleView]);

   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.keyCode === 27) {
            setIsOpenSingleViewinr(false);
            setIsOpenPurchaseReturnSingleView(false);
            setIsOpenSingleViewcnb(false);
         }
      };

      document.addEventListener('keydown', handleEscKey);
      return () => {
         document.removeEventListener('keydown', handleEscKey);
      };
   }, []);
   const handleSort = useCallback((key) => {
      setSortConfig((prevConfig) => {
         if (prevConfig.key === key) {
            // Toggle direction if same key
            return {
               key,
               direction: prevConfig.direction === 'asc' ? 'desc' : 'asc',
            };
         }
         // New key, default to descending
         return {
            key,
            direction: 'desc',
         };
      });
   }, []);

   useEffect(() => {
      if (entityType === 'item' && data && data.length > 0 && isOpenSingleView) {
         const sortedData = [...data].sort((a, b) => {
            let aValue, bValue;

            // Handle different data structures based on businessType
            if (businessType === 'NORMAL') {
               // For NORMAL business type
               switch (sortConfig.key) {
                  case 'transaction_at':
                     aValue = new Date(a.transactionAt || a.date || 0).getTime();
                     bValue = new Date(b.transactionAt || b.date || 0).getTime();
                     break;
                  case 'serial_no':
                     // For NORMAL business, use document number as fallback
                     aValue = a.docno || a.serialNo || '';
                     bValue = b.docno || b.serialNo || '';
                     break;
                  default:
                     aValue = a[sortConfig.key] || '';
                     bValue = b[sortConfig.key] || '';
               }
            } else {
               // For MOBILE business type
               switch (sortConfig.key) {
                  case 'transaction_at':
                     aValue = new Date(a.transaction_at || a.date || 0).getTime();
                     bValue = new Date(b.transaction_at || b.date || 0).getTime();
                     break;
                  case 'serial_no':
                     aValue = a.serial_no || '';
                     bValue = b.serial_no || '';
                     break;
                  default:
                     aValue = a[sortConfig.key] || '';
                     bValue = b[sortConfig.key] || '';
               }
            }

            // For date sorting (numbers)
            if (sortConfig.key === 'transaction_at') {
               if (sortConfig.direction === 'asc') {
                  return aValue - bValue;
               } else {
                  return bValue - aValue;
               }
            }

            // For serial number sorting (alphanumeric)
            if (sortConfig.key === 'serial_no') {
               // Handle alphanumeric sorting
               const aStr = String(aValue).toLowerCase();
               const bStr = String(bValue).toLowerCase();

               if (sortConfig.direction === 'asc') {
                  return aStr.localeCompare(bStr, undefined, {
                     numeric: true,
                     sensitivity: 'base',
                  });
               } else {
                  return bStr.localeCompare(aStr, undefined, {
                     numeric: true,
                     sensitivity: 'base',
                  });
               }
            }

            // For other fields (doc_no, amount)
            if (typeof aValue === 'string' && typeof bValue === 'string') {
               if (sortConfig.direction === 'asc') {
                  return aValue.localeCompare(bValue, undefined, {
                     numeric: true,
                     sensitivity: 'base',
                  });
               } else {
                  return bValue.localeCompare(aValue, undefined, {
                     numeric: true,
                     sensitivity: 'base',
                  });
               }
            }

            // For numeric fields
            if (sortConfig.direction === 'asc') {
               return aValue - bValue;
            } else {
               return bValue - aValue;
            }
         });

         setData(sortedData);
      }
   }, [sortConfig, entityType, businessType, data, isOpenSingleView]);

   useEffect(() => {
      if (entityType === 'item' && isOpenSingleView) {
         (async () => {
            try {
               if (businessType === 'NORMAL') {
                  const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);
                  const response = await dispatch(
                     getInventoryDetailReport({
                        companyIds: user?.loginhistory?.companyId,
                        search: dynamicArray?.name || basicInfo.name,
                        itemIds: singleEntity.id,
                        fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                        toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                     }),
                  );
                  const itemserialhistory = response[0]?.data[0]?.data;
                  setData(itemserialhistory);
               } else {
                  const response = await dispatch(
                     getReportSerialWiseHistory({
                        companyIds: user?.loginhistory?.companyId,
                        itemIds: ItemId || singleEntity.id,
                        sortBy: sortConfig.key,
                        sortOrder: sortConfig.direction,
                     }),
                  );
                  const itemserialhistory = response?.flatMap((data) =>
                     data.items
                        .filter((subdata) => subdata.item_name === basicInfo.name)
                        .flatMap((subdata) => subdata.transactions),
                  );

                  setData(itemserialhistory);
               }
               const res = await dispatch(
                  getStock({
                     itemId: ItemId || singleEntity.id,
                     companyId: user?.loginhistory?.companyId,
                  }),
               );
               if (res) {
                  console.log('res', res);
                  setStockData(res);
               }
            } catch (error) {
               // Error handling
            }
         })();
      }
   }, [isOpenSingleView, entityType, sortConfig.key, sortConfig.direction]);

   const balJson = singleEntity?.balJson || [];

   const companyBalance = balJson?.find((item) => String(item.compId) === String(user?.loginhistory?.companyId));

   const basicInfo = singleEntity?.basicInfo || {
      name: dynamicArray.find((item) => item.label === 'Name')?.value || '-',
      mobile: dynamicArray.find((item) => item.label === 'Mobile')?.value || '-',
      email: dynamicArray.find((item) => item.label === 'Email')?.value || '-',
      gstin: dynamicArray.find((item) => item.label === 'GSTIN')?.value || '-',
      hsn: dynamicArray.find((item) => item.label === 'HSN')?.value || '-',
      gst: dynamicArray.find((item) => item.label === 'GSTIN')?.value || '-',
      barcode: dynamicArray.find((item) => item.label === 'Barcode')?.value || '-',
      balancequantity1: companyBalance?.balancequantity1 ?? '-',
      balancequantity2: companyBalance?.balancequantity2 ?? '-',
      balancequantity3: companyBalance?.balancequantity3 ?? '-',
      stock: singleEntity?.stock || 0,
      stock2: singleEntity?.stock2 || 0,
      stock3: singleEntity?.stock3 || 0,
      balance: companyBalance?.bal || 0,
      balAmt: singleEntity?.amt || 0,
   };

   const isBlocked =
      singleEntity?.reason || singleEntity?.blockedAt || singleEntity?.blockedBy || singleEntity?.blockedbyname;
   const blockInfo = {
      reason: singleEntity?.reason || 'Not specified',
      blockedAt: singleEntity?.blockedAt ? new Date(singleEntity.blockedAt).toLocaleString('en-IN') : null,
      blockedBy: singleEntity?.blockedBy || null,
      blockedbyname: singleEntity?.blockedbyname || null,
   };

   const locationInfo = singleEntity?.locationInfo || {
      city: dynamicArray.find((item) => item.label === 'City')?.value || '-',
      state: dynamicArray.find((item) => item.label === 'State')?.value || '-',
      country: dynamicArray.find((item) => item.label === 'Country')?.value || '-',
      pincode: dynamicArray.find((item) => item.label === 'Pincode')?.value || '-',
      address: dynamicArray.find((item) => item.label === 'Address')?.value || '-',
   };

   const calculatePartyTotals = (transactions) => {
      let netTotal = 0;
      let retAdjTotal = 0;
      let otherAdjTotal = 0;
      let osTotal = 0;

      transactions.forEach((txn, i) => {
         const isFirstOfGroup = i === 0 || txn.id !== transactions[i - 1].id;
         if (isFirstOfGroup && txn.netAmount) netTotal += Number(txn.netAmount || 0);
         if (txn.returnadjamount) retAdjTotal += Number(txn.returnadjamount || 0);
         if (txn.otheradjamount) otherAdjTotal += Number(txn.otheradjamount || 0);
         if (isFirstOfGroup && txn.balanceamount) osTotal += Number(txn.balanceamount || 0);
      });

      return {
         netTotal,
         retAdjTotal,
         otherAdjTotal,
         osTotal,
      };
   };

   const renderInfoTab = () => {
      return (
         <div className="space-y-5 max-h-[calc(100vh-200px)] overflow-y-auto pr-2 pb-4">
            {/* Premium Header Section */}
            <div
               className={`relative rounded-2xl overflow-hidden transition-all duration-300 ${isDark
                  ? 'bg-slate-800 border border-slate-700/60 shadow-lg'
                  : 'bg-white border border-gray-200 shadow-md'
                  } hover:shadow-xl`}>
               <div className="relative flex items-center justify-between py-5 px-6">
                  {/* Avatar and Info Section */}
                  <div className="flex items-center gap-4">
                     {/* Avatar with gradient ring */}
                     <div className="relative flex-shrink-0">
                        {/* Gradient ring */}
                        <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-2xl blur opacity-40" />
                        <div
                           className={`relative w-14 h-14 rounded-2xl flex items-center justify-center transition-transform duration-300 hover:scale-110 ${isDark
                              ? 'bg-gradient-to-br from-blue-600 to-blue-700 shadow-lg shadow-blue-500/50'
                              : 'bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg shadow-blue-500/30'
                              }`}>
                           <span className="text-xl font-bold text-white">
                              {basicInfo.name?.charAt(0)?.toUpperCase() || 'D'}
                           </span>
                        </div>
                     </div>

                     {/* Info Section */}
                     <div className="flex-1 min-w-0">
                        <h2
                           className={`text-base font-bold mb-0.5 whitespace-pre-wrap ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {basicInfo.name || 'Unnamed'}
                        </h2>
                        {isCustomersOrVendors && (
                           <div className="flex items-center gap-1.5">
                              <svg
                                 className={`w-3.5 h-3.5 flex-shrink-0 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}
                                 fill="none"
                                 stroke="currentColor"
                                 viewBox="0 0 24 24">
                                 <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                 />
                              </svg>
                              <p className={`text-xs truncate ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                 {basicInfo.mobile || 'No mobile provided'}
                              </p>
                           </div>
                        )}
                     </div>
                  </div>

                  {/* Balance Badge */}
                  {isCustomersOrVendors && (
                     <div className="flex ml-4">
                        <div
                           className={`px-5 py-2.5 rounded-xl transition-all duration-300 hover:scale-105 ${basicInfo.balAmt > 0
                              ? isDark
                                 ? 'bg-red-500/10 border border-red-500/30'
                                 : 'bg-red-50 border border-red-200'
                              : isDark
                                 ? 'bg-green-500/10 border border-green-500/30'
                                 : 'bg-green-50 border border-green-200'
                              }`}>
                           <div className="flex items-center gap-2">
                              <p
                                 className={`text-xl font-bold whitespace-nowrap ${basicInfo.balAmt > 0 ? 'text-red-600' : 'text-green-600'
                                    }`}>
                                 ₹
                                 {Math.abs(basicInfo.balAmt || 0).toLocaleString('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                 })}
                              </p>
                              <div className="flex items-center gap-1.5">
                                 <span
                                    className={`text-[10px] font-bold px-1.5 py-0.5 rounded whitespace-nowrap ${basicInfo.balAmt > 0 ? 'bg-red-500 text-white' : 'bg-green-500 text-white'
                                       }`}>
                                    {basicInfo.balAmt > 0 ? 'DB' : 'CR'}
                                 </span>
                                 <span
                                    className={`text-[10px] font-medium whitespace-nowrap ${isDark ? 'text-gray-400' : 'text-gray-600'
                                       }`}>
                                    Balance
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  )}
                  {company.setting.maxUOM >= 1 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity1 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark
                              ? 'bg-green-500/10 border border-green-500/20'
                              : 'bg-green-50 border border-green-200'
                              }`}>
                           <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc1Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                                 {basicInfo.balancequantity1 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
                  {company.setting.maxUOM >= 2 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity2 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark ? 'bg-blue-500/10 border border-blue-500/20' : 'bg-blue-50 border border-blue-200'
                              }`}>
                           <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc2Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                                 {basicInfo.balancequantity2 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
                  {company.setting.maxUOM >= 3 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity3 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark
                              ? 'bg-purple-500/10 border border-purple-500/20'
                              : 'bg-purple-50 border border-purple-200'
                              }`}>
                           <div className="flex justify-between items-center gap-3">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc3Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-purple-400' : 'text-purple-600'}`}>
                                 {basicInfo.balancequantity3 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
                  {company.setting.maxUOM >= 1 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity1 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark
                              ? 'bg-green-500/10 border border-green-500/20'
                              : 'bg-green-50 border border-green-200'
                              }`}>
                           <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc1Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                                 {basicInfo.balancequantity1 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
                  {company.setting.maxUOM >= 2 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity2 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark ? 'bg-blue-500/10 border border-blue-500/20' : 'bg-blue-50 border border-blue-200'
                              }`}>
                           <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc2Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                                 {basicInfo.balancequantity2 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
                  {company.setting.maxUOM >= 3 &&
                     singleEntity?.itemdetailtype === 0 &&
                     basicInfo.balancequantity3 !== '-' && (
                        <div
                           className={`p-4 rounded-xl ${isDark
                              ? 'bg-purple-500/10 border border-purple-500/20'
                              : 'bg-purple-50 border border-purple-200'
                              }`}>
                           <div className="flex justify-between items-center gap-3">
                              <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                 {singleEntity?.uqc3Data?.name}
                              </span>
                              <span className={`text-2xl font-bold ${isDark ? 'text-purple-400' : 'text-purple-600'}`}>
                                 {basicInfo.balancequantity3 || '0'}
                              </span>
                           </div>
                        </div>
                     )}
               </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
               {/* Basic Information Card */}
               <div
                  className={`rounded-3xl p-6 transition-all duration-300 ${isDark
                     ? 'bg-slate-800/90 border border-slate-700/50 hover:border-slate-600'
                     : 'bg-white border border-gray-200 hover:border-gray-300'
                     } hover:shadow-xl`}>
                  <h3
                     className={`text-base font-bold mb-5 flex items-center gap-2 ${isDark ? 'text-gray-200' : 'text-gray-900'
                        }`}>
                     <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-blue-500/10' : 'bg-blue-50'
                           }`}>
                        <svg
                           className={`w-4 h-4 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                           />
                        </svg>
                     </div>
                     Basic Information
                  </h3>

                  <div className="space-y-3">
                     {isCustomersOrVendors ? (
                        <>
                           {[
                              { label: 'Mobile', value: basicInfo.mobile },
                              { label: 'Email', value: basicInfo.email },
                           ].map((item, index) => (
                              <div
                                 key={index}
                                 className={`flex justify-between items-center py-3 px-4 rounded-xl transition-colors ${isDark ? 'hover:bg-slate-700/40' : 'hover:bg-gray-50'
                                    }`}>
                                 <span className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {item.label}
                                 </span>
                                 <span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                    {item.value || '-'}
                                 </span>
                              </div>
                           ))}
                        </>
                     ) : (
                        <div
                           className={`flex justify-between items-center py-3 px-4 rounded-xl transition-colors ${isDark ? 'hover:bg-slate-700/40' : 'hover:bg-gray-50'
                              }`}>
                           <span className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                              HSN Code
                           </span>
                           <span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              {basicInfo.hsn || '-'}
                           </span>
                        </div>
                     )}

                     <div
                        className={`flex justify-between items-center py-3 px-4 rounded-xl transition-colors ${isDark ? 'hover:bg-slate-700/40' : 'hover:bg-gray-50'
                           }`}>
                        <span className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                           GSTIN
                        </span>
                        <span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {basicInfo.gstin || '-'}
                        </span>
                     </div>

                     <div
                        className={`flex justify-between items-center py-3 px-4 rounded-xl transition-colors ${isDark ? 'hover:bg-slate-700/40' : 'hover:bg-gray-50'
                           }`}>
                        <span className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                           Barcode
                        </span>
                        <span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           {basicInfo.barcode || '-'}
                        </span>
                     </div>

                     {isCustomersOrVendors && (
                        <div
                           className={`flex justify-between items-center py-3 px-4 rounded-xl ${basicInfo.balance > 0
                              ? isDark
                                 ? 'bg-red-500/10 border border-red-500/20'
                                 : 'bg-red-50 border border-red-200'
                              : isDark
                                 ? 'bg-green-500/10 border border-green-500/20'
                                 : 'bg-green-50 border border-green-200'
                              }`}>
                           <span className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                              Opening Balance
                           </span>
                           <span
                              className={`text-sm font-bold ${basicInfo.balance > 0 ? 'text-red-500' : 'text-green-500'
                                 }`}>
                              ₹
                              {Math.abs(basicInfo.balance || 0).toLocaleString('en-IN', {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })}{' '}
                              {basicInfo.balAmt > 0 ? 'DB' : 'CR'}
                           </span>
                        </div>
                     )}
                  </div>
               </div>

               {/* Location / Stock Information Card */}
               <div
                  className={`rounded-3xl p-6 transition-all duration-300 ${isDark
                     ? 'bg-slate-800/90 border border-slate-700/50 hover:border-slate-600'
                     : 'bg-white border border-gray-200 hover:border-gray-300'
                     } hover:shadow-xl`}>
                  <h3
                     className={`text-base font-bold mb-5 flex items-center gap-2 ${isDark ? 'text-gray-200' : 'text-gray-900'
                        }`}>
                     <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-purple-500/10' : 'bg-purple-50'
                           }`}>
                        <svg
                           className={`w-4 h-4 ${isDark ? 'text-purple-400' : 'text-purple-600'}`}
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d={
                                 isCustomersOrVendors
                                    ? 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z'
                                    : 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
                              }
                           />
                        </svg>
                     </div>
                     {isCustomersOrVendors ? 'Location Information' : 'Stock Information'}
                  </h3>

                  <div className="space-y-3">
                     {isCustomersOrVendors ? (
                        <>
                           {[
                              { label: 'City', value: locationInfo.city },
                              { label: 'State', value: locationInfo.state },
                              { label: 'Country', value: locationInfo.country },
                              { label: 'Pincode', value: locationInfo.pincode },
                              { label: 'Address', value: locationInfo.address },
                           ].map((item, index) => (
                              <div
                                 key={index}
                                 className={`flex justify-between items-center py-3 px-4 rounded-xl transition-colors ${isDark ? 'hover:bg-slate-700/40' : 'hover:bg-gray-50'
                                    }`}>
                                 <span className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {item.label}
                                 </span>
                                 <span
                                    className={`text-sm font-semibold text-right max-w-xs ${isDark ? 'text-white' : 'text-gray-900'
                                       }`}>
                                    {item.value || '-'}
                                 </span>
                              </div>
                           ))}
                        </>
                     ) : (
                        <>
                           {company.setting.maxUOM >= 1 && singleEntity?.itemdetailtype === 0 && (
                              <div
                                 className={`p-4 rounded-xl ${isDark
                                    ? 'bg-green-500/10 border border-green-500/20'
                                    : 'bg-green-50 border border-green-200'
                                    }`}>
                                 <div className="flex justify-between items-center">
                                    <span
                                       className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                       {singleEntity?.uqc1Data?.name}
                                    </span>
                                    <span
                                       className={`text-2xl font-bold ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                                       {basicInfo.stock || '0'}
                                    </span>
                                 </div>
                              </div>
                           )}
                           {company.setting.maxUOM >= 2 && singleEntity?.itemdetailtype === 0 && (
                              <div
                                 className={`p-4 rounded-xl ${isDark
                                    ? 'bg-blue-500/10 border border-blue-500/20'
                                    : 'bg-blue-50 border border-blue-200'
                                    }`}>
                                 <div className="flex justify-between items-center">
                                    <span
                                       className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                       {singleEntity?.uqc2Data?.name}
                                    </span>
                                    <span
                                       className={`text-2xl font-bold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                                       {basicInfo.stock2 || '0'}
                                    </span>
                                 </div>
                              </div>
                           )}
                           {company.setting.maxUOM >= 3 && singleEntity?.itemdetailtype === 0 && (
                              <div
                                 className={`p-4 rounded-xl ${isDark
                                    ? 'bg-purple-500/10 border border-purple-500/20'
                                    : 'bg-purple-50 border border-purple-200'
                                    }`}>
                                 <div className="flex justify-between items-center">
                                    <span
                                       className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                       {singleEntity?.uqc3Data?.name}
                                    </span>
                                    <span
                                       className={`text-2xl font-bold ${isDark ? 'text-purple-400' : 'text-purple-600'
                                          }`}>
                                       {basicInfo.stock3 || '0'}
                                    </span>
                                 </div>
                              </div>
                           )}
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
      );
   };

   const renderPaymentTab = () => {
      return (
         <div className="space-y-6">
            <div
               className={`rounded-2xl transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-800/60 to-slate-800/40 border border-slate-700/50 shadow-2xl shadow-slate-900/50'
                  : 'bg-white border border-gray-200 shadow-xl shadow-gray-200/50'
                  } overflow-hidden backdrop-blur-sm`}>
               {/* Header Section */}
               <div
                  className={`px-6 py-4 border-b ${isDark
                     ? 'border-slate-700/50 bg-slate-700/30'
                     : 'border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100'
                     }`}>
                  <h3
                     className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} flex items-center gap-2`}>
                     <span className={`w-1.5 h-6 rounded-full ${isDark ? 'bg-blue-500' : 'bg-blue-600'}`}></span>
                     Payment Details
                  </h3>
               </div>

               {/* Table Container */}
               <div className="overflow-x-auto max-h-[600px] overflow-y-auto custom-scrollbar">
                  <table className="w-full">
                     <thead>
                        <tr
                           className={`${isDark
                              ? 'bg-gradient-to-r from-slate-700/70 to-slate-700/50'
                              : 'bg-gradient-to-r from-gray-100 to-gray-50'
                              } border-b-2 ${isDark ? 'border-slate-600' : 'border-gray-300'
                              } sticky top-0 z-10 backdrop-blur-sm`}>
                           {[
                              'Date',
                              'V.No.',
                              'Due Days',
                              'Net Amount',
                              'Rec. Date',
                              'Rec. Book',
                              'Ret. Rec. Amt.',
                              'Oth. Rec. Amt.',
                              'OS. Amt',
                           ].map((heading, i) => (
                              <th
                                 key={i}
                                 className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                    } uppercase tracking-wider whitespace-nowrap`}>
                                 {heading}
                              </th>
                           ))}
                        </tr>
                     </thead>
                     <tbody className={`divide-y ${isDark ? 'divide-slate-700/50' : 'divide-gray-100'}`}>
                        {singleEntity?.os?.length > 0 ? (
                           singleEntity.os.map((company, cIndex) =>
                              company.data?.map((account, aIndex) => {
                                 const transactionRows = renderDataRows(account.data || []);
                                 const transactions = account.data || [];
                                 const showHeader = transactionRows && transactionRows.length > 0;
                                 const totals = calculatePartyTotals(transactions);
                                 return showHeader ? (
                                    <React.Fragment key={`company-${cIndex}-account-${aIndex}`}>
                                       {transactionRows}
                                       <tr
                                          className={`${isDark
                                             ? 'bg-gradient-to-r from-blue-500/20 to-blue-600/10 border-blue-500/30'
                                             : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200'
                                             } border-t-2 border-b hover:shadow-md transition-all duration-200`}>
                                          <td
                                             className={`px-5 py-4 font-bold text-sm ${isDark ? 'text-blue-300' : 'text-blue-900'
                                                } whitespace-nowrap`}
                                             colSpan={3}>
                                             <span className="flex items-center gap-2">
                                                <span
                                                   className={`w-2 h-2 rounded-full ${isDark ? 'bg-blue-400' : 'bg-blue-600'
                                                      } animate-pulse`}></span>
                                                Party Total:
                                             </span>
                                          </td>
                                          <td
                                             className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                                } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.netTotal)}
                                          </td>
                                          <td className="px-5 py-4" />
                                          <td className="px-5 py-4" />
                                          <td
                                             className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                                } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.retAdjTotal)}
                                          </td>
                                          <td
                                             className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                                } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.otherAdjTotal)}
                                          </td>
                                          <td
                                             className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                                } whitespace-nowrap`}>
                                             {formatAmountWithLabel(totals.osTotal)}
                                          </td>
                                       </tr>
                                    </React.Fragment>
                                 ) : null;
                              }),
                           )
                        ) : (
                           <tr>
                              <td colSpan={9} className={`px-5 py-16 text-center`}>
                                 <div className="flex flex-col items-center justify-center gap-3">
                                    <div
                                       className={`w-16 h-16 rounded-full ${isDark ? 'bg-slate-700' : 'bg-gray-100'
                                          } flex items-center justify-center`}>
                                       <svg
                                          className={`w-8 h-8 ${isDark ? 'text-slate-500' : 'text-gray-400'}`}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                          />
                                       </svg>
                                    </div>
                                    <p className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                       No payment information available
                                    </p>
                                    <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                                       Payment records will appear here once added
                                    </p>
                                 </div>
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   };

   const renderDataRows = (itemData) => {
      if (!itemData || !Array.isArray(itemData)) return null;

      return itemData.map((transaction, rowIndex) => {
         const previousTransaction = rowIndex > 0 ? itemData[rowIndex - 1] : null;
         const isSameId = previousTransaction && transaction.id === previousTransaction.id;

         const isOddRow = rowIndex % 2 !== 0;
         rowIndex++;

         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);
            if (companyId === data.companyId && data.daybooktype === 20) {
               setEntityTypesv('receivemaster');
               const response = await dispatch(getReceiveInventory(data.id));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyId && data.daybooktype === 19) {
               setEntityTypesv('issuemaster');
               const response = await dispatch(getIssueInventory(data.id));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyId && data.daybooktype === 11) {
               setEntityTypesv('purchaseinvoice');
               await dispatch(
                  getSinglePurchaseWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 5) {
               setEntityTypesv('saleinvoice');
               await dispatch(
                  getSingleWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 12) {
               setEntityTypesv('purchasereturn');
               await dispatch(getSinglePurchaseReturn(data.id));
               await dispatch(
                  getSinglePurchaseReturnWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 6) {
               setEntityTypesv('salereturn');
               await dispatch(
                  getSingleSalesReturnWithPrevAndNext({
                     id: data.id,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyId && data.daybooktype === 13) {
               setEntityTypesv('cash');
               setIsBankPageTrue(false);
               await dispatch(getOneVoucher(data.id));
               setIsOpenSingleViewcnb(true);
            }
            if (companyId === data.companyId && data.daybooktype === 14) {
               setEntityTypesv('bank');
               setIsBankPageTrue(true);
               await dispatch(getOneVoucher(data.docid));
               setIsOpenSingleViewcnb(true);
            }
         };

         return (
            <tr
               key={`row-${transaction.id || rowIndex}`}
               className={`
                  ${isOddRow ? (isDark ? 'bg-gray-700/30' : 'bg-gray-50/50') : 'transparent'}
                  ${isDark ? 'hover:bg-blue-800/30' : 'hover:bg-blue-50'}
                  transition-all duration-200 ease-in-out
                  cursor-pointer
                  border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}
               `}
               onClick={() => handledata(transaction)}>
               <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                  {!isSameId && transaction.txndate ? new Date(transaction.txndate).toLocaleDateString('en-IN') : '-'}
               </td>
               <td className="px-4 py-3 text-sm font-medium">{!isSameId ? transaction.docnumber : '-'}</td>
               <td className="px-4 py-3 text-sm text-right">{!isSameId ? transaction.dueDays : '-'}</td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {!isSameId && transaction.netAmount
                     ? Number(transaction.netAmount).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     })
                     : '-'}
               </td>
               <td className="px-4 py-3 text-sm text-right">
                  {transaction.adjtxndate ? new Date(transaction.adjtxndate).toLocaleDateString('en-IN') : '-'}
               </td>
               <td className="px-4 py-3 text-sm text-right">{transaction.adjdaybookname || '-'}</td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {transaction.returnadjamount
                     ? Number(transaction.returnadjamount).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     })
                     : '00.00'}
               </td>
               <td className="px-4 py-3 text-sm text-right font-semibold">
                  {transaction.otheradjamount
                     ? Number(transaction.otheradjamount).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     })
                     : '00.00'}
               </td>
               <td className="px-4 py-3 text-sm text-right font-bold">
                  {!isSameId && transaction.balanceamount
                     ? Number(transaction.balanceamount).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     })
                     : '-'}
               </td>
            </tr>
         );
      });
   };

   const renderStockTabForItem = () => {
      const formatDate = (dateStr) => {
         const date = new Date(dateStr);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      };

      const totals = stockData?.reduce((sum, entry) => sum + (parseFloat(entry.itemRate) || 0), 0);

      const handledata = async (data) => {
         console.log('data for single view', data);
         if (data.daybooktype === 20) {
            setEntityTypesv('receiveinventory');
            const response = await dispatch(getReceiveInventory(data.header_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 19) {
            setEntityTypesv('issueinventory');
            const response = await dispatch(getIssueInventory(data.header_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 11) {
            setEntityTypesv('purchaseinvoice');
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  id: data.header_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 5) {
            setEntityTypesv('saleinvoice');
            await dispatch(
               getSingleWithPrevAndNext({
                  id: data.header_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 12) {
            setEntityTypesv('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.doc_id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.header_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 6) {
            setEntityTypesv('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.header_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 13) {
            setEntityTypesv('cash');
            setIsBankPageTrue(false);
            await dispatch(getOneVoucher(data.header_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 14) {
            setEntityTypesv('bank');
            setIsBankPageTrue(true);
            await dispatch(getOneVoucher(data.header_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 18) {
            setEntityTypesv('JV');
            const response = await dispatch(
               getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
            );
            setCurrentRow(response[0]);
            setisOpenJV(true);
            setIsEditMode(true);
         }
      };

      return (
         <div className="space-y-6">
            <div
               className={`rounded-2xl transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-800/60 to-slate-800/40 border border-slate-700/50 shadow-2xl shadow-slate-900/50'
                  : 'bg-white border border-gray-200 shadow-xl shadow-gray-200/50'
                  } overflow-hidden backdrop-blur-sm`}>
               {/* Header Section */}
               <div
                  className={`px-6 py-4 border-b ${isDark
                     ? 'border-slate-700/50 bg-slate-700/30'
                     : 'border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100'
                     }`}>
                  <h3
                     className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} flex items-center gap-2`}>
                     <span className={`w-1.5 h-6 rounded-full ${isDark ? 'bg-purple-500' : 'bg-purple-600'}`}></span>
                     Stock Movement Details
                  </h3>
               </div>

               {/* Table Container */}
               <div className="overflow-x-auto max-h-[600px] overflow-y-auto custom-scrollbar">
                  <table className="w-full">
                     <thead>
                        <tr
                           className={`${isDark
                              ? 'bg-gradient-to-r from-slate-700/70 to-slate-700/50'
                              : 'bg-gradient-to-r from-gray-100 to-gray-50'
                              } border-b-2 ${isDark ? 'border-slate-600' : 'border-gray-300'
                              } sticky top-0 z-10 backdrop-blur-sm`}>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Date
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Doc#
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Daybook
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Account
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Warehouse
                           </th>
                           {businessType !== 'NORMAL' && (
                              <th
                                 className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                    } uppercase tracking-wider whitespace-nowrap`}>
                                 Serial No
                              </th>
                           )}
                           <th
                              className={`px-5 py-4 text-right text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Item Rate (₹)
                           </th>
                        </tr>
                     </thead>
                     <tbody className={`divide-y ${isDark ? 'divide-slate-700/50' : 'divide-gray-100'}`}>
                        {stockData?.length > 0 ? (
                           <>
                              {stockData.map((transaction, index) => {
                                 const isOddRow = index % 2 !== 0;

                                 return (
                                    <tr
                                       key={index}
                                       className={`
                                       ${isOddRow ? (isDark ? 'bg-slate-700/20' : 'bg-gray-50/70') : 'transparent'}
                                       ${isDark
                                             ? 'hover:bg-purple-500/10 hover:shadow-lg'
                                             : 'hover:bg-purple-50 hover:shadow-md'
                                          }
                                       transition-all duration-200
                                       cursor-pointer
                                       border-l-2 border-transparent hover:border-l-purple-500
                                    `}
                                       onClick={() => handledata(transaction)}>
                                       <td
                                          className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-gray-200' : 'text-gray-700'
                                             } whitespace-nowrap`}>
                                          {formatDate(transaction?.transactionAt)}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-purple-400' : 'text-purple-600'
                                             } whitespace-nowrap`}>
                                          {transaction?.docno}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             } whitespace-nowrap`}>
                                          {transaction?.daybook}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             } whitespace-nowrap`}>
                                          {transaction?.account}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             } whitespace-nowrap`}>
                                          <span
                                             className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${isDark ? 'bg-slate-700 text-gray-300' : 'bg-gray-100 text-gray-700'
                                                }`}>
                                             <svg
                                                className="w-3 h-3"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={2}
                                                   d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                />
                                             </svg>
                                             {transaction?.warehouseName}
                                          </span>
                                       </td>
                                       {businessType !== 'NORMAL' && (
                                          <td
                                             className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                } whitespace-nowrap`}>
                                             {transaction?.serialNo || '-'}
                                          </td>
                                       )}
                                       <td
                                          className={`px-5 py-3.5 text-sm text-right font-semibold ${isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                          {formatAmountWithLabel(transaction?.itemRate)}
                                       </td>
                                    </tr>
                                 );
                              })}

                              <tr
                                 className={`${isDark
                                    ? 'bg-gradient-to-r from-purple-500/20 to-purple-600/10 border-purple-500/30'
                                    : 'bg-gradient-to-r from-purple-50 to-violet-50 border-purple-200'
                                    } border-t-2 border-b hover:shadow-md transition-all duration-200`}>
                                 <td
                                    colSpan={businessType !== 'NORMAL' ? 6 : 5}
                                    className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-purple-300' : 'text-purple-900'
                                       } whitespace-nowrap`}>
                                    <span className="flex items-center justify-end gap-2">
                                       <span
                                          className={`w-2 h-2 rounded-full ${isDark ? 'bg-purple-400' : 'bg-purple-600'
                                             } animate-pulse`}></span>
                                       Total
                                    </span>
                                 </td>
                                 <td
                                    className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                       } whitespace-nowrap`}>
                                    {formatAmountWithLabel(totals)}
                                 </td>
                              </tr>
                           </>
                        ) : (
                           <tr>
                              <td colSpan={businessType !== 'NORMAL' ? 7 : 6} className="px-5 py-16 text-center">
                                 <div className="flex flex-col items-center justify-center gap-3">
                                    <div
                                       className={`w-16 h-16 rounded-full ${isDark ? 'bg-slate-700' : 'bg-gray-100'
                                          } flex items-center justify-center`}>
                                       <svg
                                          className={`w-8 h-8 ${isDark ? 'text-slate-500' : 'text-gray-400'}`}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                          />
                                       </svg>
                                    </div>
                                    <p className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                       No Stock Data Available
                                    </p>
                                    <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                                       Stock movement records will appear here once added
                                    </p>
                                 </div>
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   };

   const SortIcon = ({ columnKey }) => {
      return (
         <span className="ml-1">
            {sortConfig.direction === 'asc' ? '↑' : '↓'}
            <span className="sr-only">{sortConfig.direction === 'asc' ? 'Ascending' : 'Descending'}</span>
         </span>
      );
   };

   const renderStatementTabForItem = () => {
      const formatDate = (dateStr) => {
         const date = new Date(dateStr);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      };

      const totals = data?.reduce(
         (sum, entry) => sum + (parseFloat(businessType === 'NORMAL' ? entry.bal1 : entry.doc_net_amount) || 0),
         0,
      );

      const handledata = async (data) => {
         if (data.daybook_type === 20) {
            setEntityTypesv('receiveinventory');
            const response = await dispatch(getReceiveInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 19) {
            setEntityTypesv('issueinventory');
            const response = await dispatch(getIssueInventory(data.doc_id));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 11) {
            setEntityTypesv('purchaseinvoice');
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 5) {
            setEntityTypesv('saleinvoice');
            await dispatch(
               getSingleWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 12) {
            setEntityTypesv('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.doc_id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 6) {
            setEntityTypesv('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.doc_id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybook_type === 13) {
            setEntityTypesv('cash');
            setIsBankPageTrue(false);
            await dispatch(getOneVoucher(data.doc_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybook_type === 14) {
            setEntityTypesv('bank');
            setIsBankPageTrue(true);
            await dispatch(getOneVoucher(data.doc_id));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybook_type === 18) {
            setEntityTypesv('JV');
            const response = await dispatch(
               getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
            );
            setCurrentRow(response[0]);
            setisOpenJV(true);
            setIsEditMode(true);
         }
      };

      return (
         <div className="space-y-6">
            <div
               className={`rounded-2xl transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-800/60 to-slate-800/40 border border-slate-700/50 shadow-2xl shadow-slate-900/50'
                  : 'bg-white border border-gray-200 shadow-xl shadow-gray-200/50'
                  } overflow-hidden backdrop-blur-sm`}>
               {/* Header Section */}
               <div
                  className={`px-6 py-4 border-b ${isDark
                     ? 'border-slate-700/50 bg-slate-700/30'
                     : 'border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100'
                     }`}>
                  <h3
                     className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} flex items-center gap-2`}>
                     <span className={`w-1.5 h-6 rounded-full ${isDark ? 'bg-amber-500' : 'bg-amber-600'}`}></span>
                     Item Statement
                  </h3>
               </div>

               {/* Table Container */}
               <div className="overflow-x-auto max-h-[600px] overflow-y-auto custom-scrollbar">
                  <table className="w-full">
                     <thead>
                        <tr
                           className={`${isDark
                              ? 'bg-gradient-to-r from-slate-700/70 to-slate-700/50'
                              : 'bg-gradient-to-r from-gray-100 to-gray-50'
                              } border-b-2 ${isDark ? 'border-slate-600' : 'border-gray-300'
                              } sticky top-0 z-10 backdrop-blur-sm`}>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider cursor-pointer ${isDark ? 'hover:bg-slate-600/50' : 'hover:bg-gray-200'
                                 } transition-colors whitespace-nowrap group`}
                              onClick={() => handleSort('created_at')}>
                              <div className="flex items-center gap-1.5">
                                 <span>Date</span>
                                 <span className="opacity-60 group-hover:opacity-100 transition-opacity">
                                    <SortIcon columnKey="created_at" />
                                 </span>
                              </div>
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Doc#
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Daybook
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Account
                           </th>
                           {businessType !== 'NORMAL' && (
                              <th
                                 className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                    } uppercase tracking-wider cursor-pointer ${isDark ? 'hover:bg-slate-600/50' : 'hover:bg-gray-200'
                                    } transition-colors whitespace-nowrap group`}
                                 onClick={() => handleSort('serial_no')}>
                                 <div className="flex items-center gap-1.5">
                                    <span>Serial No</span>
                                    <span className="opacity-60 group-hover:opacity-100 transition-opacity">
                                       <SortIcon columnKey="serial_no" />
                                    </span>
                                 </div>
                              </th>
                           )}
                           <th
                              className={`px-5 py-4 text-right text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Balance (₹)
                           </th>
                        </tr>
                     </thead>
                     <tbody className={`divide-y ${isDark ? 'divide-slate-700/50' : 'divide-gray-100'}`}>
                        {data?.length > 0 ? (
                           <>
                              {data.map((transaction, index) => {
                                 const isOddRow = index % 2 !== 0;

                                 return (
                                    <tr
                                       key={index}
                                       className={`
                                       ${isOddRow ? (isDark ? 'bg-slate-700/20' : 'bg-gray-50/70') : 'transparent'}
                                       ${isDark
                                             ? 'hover:bg-amber-500/10 hover:shadow-lg'
                                             : 'hover:bg-amber-50 hover:shadow-md'
                                          }
                                       transition-all duration-200
                                       cursor-pointer
                                       border-l-2 border-transparent hover:border-l-amber-500
                                    `}
                                       onClick={() => handledata(transaction)}>
                                       <td
                                          className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-gray-200' : 'text-gray-700'
                                             } whitespace-nowrap`}>
                                          {businessType === 'NORMAL'
                                             ? formatDate(transaction?.transactionAt)
                                             : formatDate(transaction?.transaction_at)}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-amber-400' : 'text-amber-600'
                                             } whitespace-nowrap`}>
                                          {businessType === 'NORMAL' ? transaction?.docno : transaction?.doc_no || '-'}
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             } whitespace-nowrap`}>
                                          <span
                                             className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${isDark ? 'bg-slate-700/50 text-gray-300' : 'bg-gray-100 text-gray-700'
                                                }`}>
                                             {businessType === 'NORMAL'
                                                ? transaction?.daybookName
                                                : transaction?.daybook_name || '-'}
                                          </span>
                                       </td>
                                       <td
                                          className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             } whitespace-nowrap`}>
                                          {businessType === 'NORMAL'
                                             ? transaction?.accountName
                                             : transaction?.account_name || '-'}
                                       </td>
                                       {businessType !== 'NORMAL' && (
                                          <td
                                             className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                } whitespace-nowrap`}>
                                             <span
                                                className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-mono ${isDark ? 'bg-slate-700 text-amber-400' : 'bg-amber-50 text-amber-700'
                                                   }`}>
                                                {transaction?.serial_no || '-'}
                                             </span>
                                          </td>
                                       )}
                                       <td
                                          className={`px-5 py-3.5 text-sm text-right font-semibold ${isDark ? 'text-white' : 'text-gray-900'
                                             } whitespace-nowrap`}>
                                          {businessType === 'NORMAL'
                                             ? formatAmountWithLabel(transaction?.bal1)
                                             : formatAmountWithLabel(transaction?.doc_net_amount)}
                                       </td>
                                    </tr>
                                 );
                              })}

                              <tr
                                 className={`${isDark
                                    ? 'bg-gradient-to-r from-amber-500/20 to-amber-600/10 border-amber-500/30'
                                    : 'bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200'
                                    } border-t-2 border-b hover:shadow-md transition-all duration-200`}>
                                 <td
                                    colSpan={businessType === 'NORMAL' ? 4 : 5}
                                    className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-amber-300' : 'text-amber-900'
                                       } whitespace-nowrap`}>
                                    <span className="flex items-center justify-end gap-2">
                                       <span
                                          className={`w-2 h-2 rounded-full ${isDark ? 'bg-amber-400' : 'bg-amber-600'
                                             } animate-pulse`}></span>
                                       Total
                                    </span>
                                 </td>
                                 <td
                                    className={`px-5 py-4 text-right font-bold text-sm ${isDark ? 'text-white' : 'text-gray-900'
                                       } whitespace-nowrap`}>
                                    {formatAmountWithLabel(totals)}
                                 </td>
                              </tr>
                           </>
                        ) : (
                           <tr>
                              <td colSpan={businessType === 'NORMAL' ? 6 : 7} className="px-5 py-16 text-center">
                                 <div className="flex flex-col items-center justify-center gap-3">
                                    <div
                                       className={`w-16 h-16 rounded-full ${isDark ? 'bg-slate-700' : 'bg-gray-100'
                                          } flex items-center justify-center`}>
                                       <svg
                                          className={`w-8 h-8 ${isDark ? 'text-slate-500' : 'text-gray-400'}`}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                          />
                                       </svg>
                                    </div>
                                    <p className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                       No statement information available
                                    </p>
                                    <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                                       Item transaction records will appear here once added
                                    </p>
                                 </div>
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   };

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      if (entityTypesv === 'purchasereturn') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'salereturn') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'saleinvoice') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      if (entityTypesv === 'purchaseinvoice') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
            handleRefreshData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleSave = async () => {
      console.log('jv save');
   };

   const renderStatementTab = () => {
      const singleAccount = singleEntity?.ledger?.[0]?.accounts?.[0];
      const formatDate = (dateStr) => {
         const date = new Date(dateStr);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0');
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      };

      const totals = singleAccount?.data?.reduce(
         (acc, transaction) => {
            const amount = Number(transaction.amount) || 0;
            const bal = Number(transaction.bal) || 0;
            if (amount < 0) acc.totalDebit += Math.abs(amount);
            if (amount > 0) acc.totalCredit += amount;
            acc.finalBalance = bal;
            return acc;
         },
         { totalDebit: 0, totalCredit: 0, finalBalance: 0 },
      );

      const handledata = async (data) => {
         if (data.daybooktype === 20) {
            setEntityTypesv('receivemaster');
            const response = await dispatch(getReceiveInventory(data.docid));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.daybooktype === 19) {
            setEntityTypesv('issuemaster');
            const response = await dispatch(getIssueInventory(data.docid));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.daybooktype === 11) {
            setEntityTypesv('purchaseinvoice');
            await dispatch(
               getSinglePurchaseWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 5) {
            setEntityTypesv('saleinvoice');
            await dispatch(
               getSingleWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 12) {
            setEntityTypesv('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.docid));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 6) {
            setEntityTypesv('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.docid,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.daybooktype === 13) {
            setEntityTypesv('cash');
            setIsBankPageTrue(false);
            await dispatch(getOneVoucher(data.docid));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 14) {
            setEntityTypesv('bank');
            setIsBankPageTrue(true);
            await dispatch(getOneVoucher(data.docid));
            setIsOpenSingleViewcnb(true);
         }
         if (data.daybooktype === 18) {
            setEntityTypesv('JV');
            const response = await dispatch(
               getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
            );
            setCurrentRow(response[0]);
            setisOpenJV(true);
            setIsEditMode(true);
         }
      };

      return (
         <div className="space-y-6">
            <div
               className={`rounded-2xl transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-800/60 to-slate-800/40 border border-slate-700/50 shadow-2xl shadow-slate-900/50'
                  : 'bg-white border border-gray-200 shadow-xl shadow-gray-200/50'
                  } overflow-hidden backdrop-blur-sm`}>
               {/* Header Section */}
               <div
                  className={`px-6 py-4 border-b ${isDark
                     ? 'border-slate-700/50 bg-slate-700/30'
                     : 'border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100'
                     }`}>
                  <h3
                     className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'} flex items-center gap-2`}>
                     <span className={`w-1.5 h-6 rounded-full ${isDark ? 'bg-emerald-500' : 'bg-emerald-600'}`}></span>
                     Account Statement
                  </h3>
               </div>

               {/* Table Container */}
               <div className="overflow-x-auto max-h-[600px] overflow-y-auto custom-scrollbar">
                  <table className="w-full">
                     <thead>
                        <tr
                           className={`${isDark
                              ? 'bg-gradient-to-r from-slate-700/70 to-slate-700/50'
                              : 'bg-gradient-to-r from-gray-100 to-gray-50'
                              } border-b-2 ${isDark ? 'border-slate-600' : 'border-gray-300'
                              } sticky top-0 z-10 backdrop-blur-sm`}>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Date
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Doc#
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Daybook
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              ContraAccount
                           </th>
                           <th
                              className={`px-5 py-4 text-left text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Particulars
                           </th>
                           <th
                              className={`px-5 py-4 text-right text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Debit (₹)
                           </th>
                           <th
                              className={`px-5 py-4 text-right text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Credit (₹)
                           </th>
                           <th
                              className={`px-5 py-4 text-right text-xs font-bold ${isDark ? 'text-gray-200' : 'text-gray-700'
                                 } uppercase tracking-wider whitespace-nowrap`}>
                              Balance (₹)
                           </th>
                        </tr>
                     </thead>
                     <tbody className={`divide-y ${isDark ? 'divide-slate-700/50' : 'divide-gray-100'}`}>
                        {singleAccount?.data?.length > 0 ? (
                           <>
                              {/* Opening Balance Row */}
                              <tr
                                 className={`${isDark
                                    ? 'bg-gradient-to-r from-emerald-500/20 to-emerald-600/10 border-emerald-500/30'
                                    : 'bg-gradient-to-r from-emerald-50 to-teal-50 border-emerald-200'
                                    } border-y-2 font-semibold`}>
                                 <td
                                    className={`px-5 py-4 text-sm font-bold ${isDark ? 'text-emerald-300' : 'text-emerald-900'
                                       } whitespace-nowrap`}
                                    colSpan={2}>
                                    <span className="flex items-center gap-2">
                                       <span
                                          className={`w-2 h-2 rounded-full ${isDark ? 'bg-emerald-400' : 'bg-emerald-600'
                                             }`}></span>
                                       Opening Balance: {formatAmountWithLabel(singleAccount?.openingBalance)}
                                    </span>
                                 </td>
                                 <td
                                    colSpan={3}
                                    className={`px-5 py-4 text-right text-sm font-bold ${isDark ? 'text-emerald-300' : 'text-emerald-900'
                                       } whitespace-nowrap`}>
                                    Total
                                 </td>
                                 <td
                                    className={`px-5 py-4 text-right text-sm font-bold ${isDark ? 'text-red-400' : 'text-red-600'
                                       } whitespace-nowrap`}>
                                    {formatAmountWithLabel(-totals.totalDebit)}
                                 </td>
                                 <td
                                    className={`px-5 py-4 text-right text-sm font-bold ${isDark ? 'text-green-400' : 'text-green-600'
                                       } whitespace-nowrap`}>
                                    {formatAmountWithLabel(totals.totalCredit)}
                                 </td>
                                 <td
                                    className={`px-5 py-4 text-right text-sm font-bold ${isDark ? 'text-white' : 'text-gray-900'
                                       } whitespace-nowrap`}>
                                    {formatAmountWithLabel(totals.finalBalance)}
                                 </td>
                              </tr>
                              {singleAccount.data
                                 .slice()
                                 .reverse()
                                 .map((transaction, index) => {
                                    const isOddRow = index % 2 !== 0;

                                    return (
                                       <tr
                                          key={index}
                                          className={`
                                          ${isOddRow ? (isDark ? 'bg-slate-700/20' : 'bg-gray-50/70') : 'transparent'}
                                          ${isDark
                                                ? 'hover:bg-blue-500/10 hover:shadow-lg'
                                                : 'hover:bg-blue-50 hover:shadow-md'
                                             }
                                          transition-all duration-200
                                          cursor-pointer
                                          border-l-2 border-transparent hover:border-l-blue-500
                                       `}
                                          onClick={() => handledata(transaction)}>
                                          <td
                                             className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-gray-200' : 'text-gray-700'
                                                } whitespace-nowrap`}>
                                             {formatDate(transaction.date)}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm font-medium ${isDark ? 'text-blue-400' : 'text-blue-600'
                                                } whitespace-nowrap`}>
                                             {transaction.docnumber || '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                } whitespace-nowrap`}>
                                             {transaction.daybookname || '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                } whitespace-nowrap`}>
                                             {transaction.daybookaccountname || '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                } whitespace-nowrap max-w-xs truncate`}>
                                             {transaction.particulars || '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm text-right font-semibold whitespace-nowrap ${transaction.amount < 0
                                                ? isDark
                                                   ? 'text-red-400'
                                                   : 'text-red-600'
                                                : isDark
                                                   ? 'text-gray-600'
                                                   : 'text-gray-400'
                                                }`}>
                                             {transaction.amount < 0 ? formatAmountWithLabel(transaction.amount) : '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm text-right font-semibold whitespace-nowrap ${transaction.amount > 0
                                                ? isDark
                                                   ? 'text-green-400'
                                                   : 'text-green-600'
                                                : isDark
                                                   ? 'text-gray-600'
                                                   : 'text-gray-400'
                                                }`}>
                                             {transaction.amount > 0 ? formatAmountWithLabel(transaction.amount) : '-'}
                                          </td>
                                          <td
                                             className={`px-5 py-3.5 text-sm text-right font-bold ${isDark ? 'text-white' : 'text-gray-900'
                                                } whitespace-nowrap`}>
                                             {formatAmountWithLabel(transaction.bal)}
                                             <span
                                                className={`ml-2 text-xs px-2 py-0.5 rounded-full font-semibold ${transaction.bal > 0
                                                   ? 'bg-red-500/20 text-red-500'
                                                   : 'bg-green-500/20 text-green-500'
                                                   }`}>
                                                {transaction.bal > 0 ? 'DB' : 'CR'}
                                             </span>
                                          </td>
                                       </tr>
                                    );
                                 })}
                           </>
                        ) : (
                           <tr>
                              <td colSpan={8} className="px-5 py-16 text-center">
                                 <div className="flex flex-col items-center justify-center gap-3">
                                    <div
                                       className={`w-16 h-16 rounded-full ${isDark ? 'bg-slate-700' : 'bg-gray-100'
                                          } flex items-center justify-center`}>
                                       <svg
                                          className={`w-8 h-8 ${isDark ? 'text-slate-500' : 'text-gray-400'}`}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                          />
                                       </svg>
                                    </div>
                                    <p className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                       No statement information available
                                    </p>
                                    <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                                       Transaction records will appear here once added
                                    </p>
                                 </div>
                              </td>
                           </tr>
                        )}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   };

   const [isOpen, setIsOpen] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [currentRow, setCurrentRow] = useState(null);

   const handleEditClick = (rowData) => {
      setIsEditMode(true);
      setCurrentRow(rowData);
      setIsOpen(true);
   };

   const handleClose = (rowData) => {
      setIsOpen(false);
   };
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };
   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            if (formType === 'Vendor') {
               await dispatch(deleteVendor(selectedRowId, user?.loginhistory?.companyId));
            } else if (formType === 'Customer') {
               await dispatch(deleteCustomer(selectedRowId, user?.loginhistory?.companyId));
            } else if (formType === 'Item') {
               await dispatch(deleteItem(selectedRowId, user?.loginhistory?.companyId));
            } else if (formType === 'daybook') {
               await dispatch(deleteDaybook(selectedRowId, user?.loginhistory?.companyId));
            } else if (formType === 'Account') {
               await dispatch(deleteCustomer(selectedRowId, user?.loginhistory?.companyId));
            }
            setDeleteDialogOpen(false);
            onClose(true);
         } catch (err) {
            console.error('Failed to delete series:', err);
         }
      }
   };

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      await dispatch(
         getAccount({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldSendIdInAccount && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({
         ...prev,
         id,
         ...rowData,
      }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   const handleRefreshData = async () => {
      setIsRotating(!isRotating);
      if (entityType === 'item') {
         onClose();
         setData([]);
      }
      reCall && reCall(singleEntity?.id);
   };

   return (
      <>
         <Modal
            isOpen={isOpenSingleView}
            onClose={() => {
               onClose();
               setData([]);
            }}
            size="6xl"
            overflowY="hidden">
            <ModalOverlay className="backdrop-blur-sm" />
            <ModalContent
               className={`
         ${isDark ? 'bg-slate-900 border border-slate-700' : 'bg-white border border-gray-200'} 
         rounded-xl shadow-2xl
      `}
               mx="15px">
               <ModalHeader className={`px-6 py-4 border-b ${isDark ? 'border-slate-700' : 'border-gray-200'}`}>
                  <div className="flex items-center justify-between">
                     <div className="flex items-center space-x-3">
                        {/* Blue indicator line */}
                        <div
                           className={`w-1 h-6 rounded-full ${isBlocked
                              ? isDark
                                 ? 'bg-red-500'
                                 : 'bg-red-600'
                              : isDark
                                 ? 'bg-blue-500'
                                 : 'bg-blue-600'
                              }`}></div>

                        {/* Title with block indicator */}
                        <div className="flex items-center gap-3">
                           <h2
                              className={`text-xl font-semibold whitespace-pre-wrap ${isDark ? 'text-white' : 'text-gray-900'}`}>
                              {dynamicArray?.name || basicInfo.name || 'Details'}
                           </h2>

                           {/* Blocked Badge - Always visible in header */}
                           {isBlocked && (
                              <div className="flex items-center gap-2">
                                 <span
                                    className={`
                     px-3 py-1 text-xs font-semibold rounded-full flex items-center gap-1.5
                     ${isDark
                                          ? 'bg-red-900/30 text-red-300 border border-red-700'
                                          : 'bg-red-100 text-red-700 border border-red-200'
                                       }
                  `}>
                                    <svg
                                       className="w-3 h-3"
                                       fill="currentColor"
                                       viewBox="0 0 20 20"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path
                                          fillRule="evenodd"
                                          d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                                          clipRule="evenodd"
                                       />
                                    </svg>
                                    BLOCKED
                                 </span>

                                 {/* Quick info tooltip/hover text */}
                                 <div className={`text-xs ${isDark ? 'text-red-400' : 'text-red-600'}`}>
                                    <div>Reason: {blockInfo.reason}</div>
                                 </div>
                              </div>
                           )}
                        </div>
                     </div>

                     {/* Actions section */}
                     <div className="flex items-center space-x-2 mr-5">
                        {/* Refresh button */}
                        <IconButton
                           icon={
                              <Box
                                 as={FiRefreshCcw}
                                 transform={isRotating ? 'rotate(-360deg)' : 'rotate(0deg)'}
                                 transition="transform 1s ease"
                              />
                           }
                           aria-label="Refresh"
                           variant="ghost"
                           size="lg"
                           _hover={{ bg: 'whiteAlpha.500' }}
                           borderRadius="lg"
                           onClick={handleRefreshData}
                        />

                        {/* Edit/Delete Menu - Conditionally disable if blocked */}
                        {(Admin || singleEntityRights?.edit || singleEntityRights?.deleteRole) && !user.isExpired && (
                           <Menu>
                              <MenuButton
                                 as={Box}
                                 cursor={isBlocked ? 'not-allowed' : 'pointer'}
                                 className={`
                     p-2 rounded-lg transition-all duration-200 mr-5
                     ${isDark
                                       ? isBlocked
                                          ? 'opacity-50 cursor-not-allowed text-gray-500'
                                          : 'hover:bg-slate-800 text-gray-300'
                                       : isBlocked
                                          ? 'opacity-50 cursor-not-allowed text-gray-400'
                                          : 'hover:bg-gray-100 text-gray-600'
                                    }
                  `}
                                 title={isBlocked ? 'Account is blocked. Cannot edit/delete.' : 'menu'}
                                 disabled={isBlocked}>
                                 <img src={dotIcon} alt="Menu" width={23} />
                              </MenuButton>

                              {!isBlocked && (
                                 <MenuList
                                    className={`
                        ${isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-gray-200'}
                        shadow-xl rounded-xl p-2
                     `}>
                                    {(Admin || singleEntityRights?.edit) && (
                                       <MenuItem
                                          onClick={handleEditClick}
                                          className={`
                              flex items-center space-x-3 px-3 py-2 rounded-lg
                              ${isDark ? 'hover:bg-slate-700 text-gray-200' : 'hover:bg-blue-50 text-gray-700'}
                              transition-colors duration-200
                           `}>
                                          <MdOutlineEdit
                                             size={20}
                                             className={isDark ? 'text-blue-400' : 'text-blue-600'}
                                          />
                                          <span className="font-medium">Edit</span>
                                       </MenuItem>
                                    )}

                                    {(Admin || singleEntityRights?.deleteRole) && !singleEntity?.isAbs && (
                                       <MenuItem
                                          onClick={() => handleDeleteClick(singleEntity.id)}
                                          className={`
              flex items-center space-x-3 px-3 py-2 rounded-lg
              ${isDark ? 'hover:bg-slate-700 text-red-400' : 'hover:bg-red-50 text-red-600'}
              transition-colors duration-200
            `}>
                                          <MdDeleteOutline size={20} />
                                          <span className="font-medium">Delete</span>
                                       </MenuItem>
                                    )}
                                 </MenuList>
                              )}
                           </Menu>
                        )}

                        {/* Close button */}
                        <ModalCloseButton
                           className={`
               relative top-0 right-0 w-8 h-8 rounded-lg
               ${isDark ? 'text-gray-400 hover:bg-slate-800' : 'text-gray-500 hover:bg-gray-100'}
               transition-colors duration-200
            `}
                        />
                     </div>
                  </div>

                  {/* Additional blocked info banner */}
                  {isBlocked && (
                     <div
                        className={`
         mt-3 px-4 py-2.5 rounded-lg border flex items-center justify-between
         ${isDark ? 'bg-red-900/20 border-red-700 text-red-300' : 'bg-red-50 border-red-200 text-red-700'}
      `}>
                        <div className="flex items-center gap-4">
                           <div className="flex items-center gap-2">
                              <svg
                                 className="w-4 h-4"
                                 fill="currentColor"
                                 viewBox="0 0 20 20"
                                 xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                 />
                              </svg>
                              <span className="font-medium">This account is blocked</span>
                           </div>

                           <div className="text-sm flex items-center gap-3">
                              <span>
                                 <span className="opacity-80">Reason : </span>
                                 <span className="font-medium ml-1">{blockInfo.reason}</span>
                              </span>

                              <span className="h-4 w-px bg-current opacity-30"></span>

                              <span>
                                 <span className="opacity-80">Blocked on : </span>
                                 <span className="font-medium ml-1">{blockInfo.blockedAt}</span>
                              </span>

                              <span className="h-4 w-px bg-current opacity-30"></span>

                              <span>
                                 <span className="opacity-80">Blocked By : </span>
                                 <span className="font-medium ml-1">{blockInfo.blockedbyname}</span>
                              </span>
                           </div>
                        </div>
                     </div>
                  )}
               </ModalHeader>
               <ModalBody className="px-6 py-6">
                  {/* Enhanced Tabs */}
                  <div className={`flex space-x-2 p-1 rounded-lg mb-6 ${isDark ? 'bg-slate-800' : 'bg-gray-100'}`}>
                     <button
                        onClick={() => setActiveTab('information')}
                        className={`
      flex-1 px-4 py-2.5 rounded-md text-sm font-medium 
      transition-all duration-300
      relative
      ${activeTab === 'information'
                              ? isDark
                                 ? 'bg-blue-600 text-white shadow-lg'
                                 : 'bg-white text-blue-600 shadow-sm'
                              : isDark
                                 ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                                 : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                           }
      after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 
      ${isDark ? 'after:bg-blue-400' : 'after:bg-blue-500'}
      after:transition-all after:duration-300
      after:shadow-[0_0_10px_rgba(59,130,246,0.8)]
      ${activeTab === 'information' ? 'after:scale-x-100' : 'after:scale-x-0 hover:after:scale-x-50'}
    `}>
                        Information
                     </button>

                     {isCustomersOrVendors && (
                        <button
                           onClick={() => setActiveTab('payment')}
                           className={`
        flex-1 px-4 py-2.5 rounded-md text-sm font-medium 
        transition-all duration-300
        relative
        ${activeTab === 'payment'
                                 ? isDark
                                    ? 'bg-blue-600 text-white shadow-lg'
                                    : 'bg-white text-blue-600 shadow-sm'
                                 : isDark
                                    ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                              }
        after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 
        ${isDark ? 'after:bg-blue-400' : 'after:bg-blue-500'}
        after:transition-all after:duration-300
        after:shadow-[0_0_10px_rgba(59,130,246,0.8)]
        ${activeTab === 'payment' ? 'after:scale-x-100' : 'after:scale-x-0 hover:after:scale-x-50'}
      `}>
                           Outstanding
                        </button>
                     )}

                     <button
                        onClick={() => setActiveTab('statement')}
                        className={`
      flex-1 px-4 py-2.5 rounded-md text-sm font-medium 
      transition-all duration-300
      relative
      ${activeTab === 'statement'
                              ? isDark
                                 ? 'bg-blue-600 text-white shadow-lg'
                                 : 'bg-white text-blue-600 shadow-sm'
                              : isDark
                                 ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                                 : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                           }
      after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 
      ${isDark ? 'after:bg-blue-400' : 'after:bg-blue-500'}
      after:transition-all after:duration-300
      after:shadow-[0_0_10px_rgba(59,130,246,0.8)]
      ${activeTab === 'statement' ? 'after:scale-x-100' : 'after:scale-x-0 hover:after:scale-x-50'}
    `}>
                        Statement
                     </button>

                     {entityType === 'item' && (
                        <button
                           onClick={() => setActiveTab('stock')}
                           className={`
        flex-1 px-4 py-2.5 rounded-md text-sm font-medium 
        transition-all duration-300
        relative
        ${activeTab === 'stock'
                                 ? isDark
                                    ? 'bg-blue-600 text-white shadow-lg'
                                    : 'bg-white text-blue-600 shadow-sm'
                                 : isDark
                                    ? 'text-gray-400 hover:text-white hover:bg-slate-700'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                              }
        after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 
        ${isDark ? 'after:bg-blue-400' : 'after:bg-blue-500'}
        after:transition-all after:duration-300
        after:shadow-[0_0_10px_rgba(59,130,246,0.8)]
        ${activeTab === 'stock' ? 'after:scale-x-100' : 'after:scale-x-0 hover:after:scale-x-50'}
      `}>
                           Stock
                        </button>
                     )}
                  </div>

                  {/* Content Area */}
                  <div className="min-h-[400px]">
                     {activeTab === 'information' && renderInfoTab()}
                     {activeTab === 'payment' && isCustomersOrVendors && renderPaymentTab()}
                     {activeTab === 'statement' &&
                        (entityType === 'item' ? renderStatementTabForItem() : renderStatementTab())}
                     {activeTab === 'stock' &&
                        entityType === 'item' &&
                        businessType === 'MOBILE' &&
                        renderStockTabForItem()}
                  </div>
               </ModalBody>

               {/* Enhanced Footer */}
               <div
                  className={`
    px-6 py-4 border-t backdrop-blur-sm
    ${isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/60 to-slate-800/40'
                        : 'border-gray-200 bg-gradient-to-r from-gray-50 to-white'
                     }
    rounded-b-xl
  `}>
                  <div className="flex justify-end items-center space-x-3">
                     {activeTab !== 'statement' && (
                        <button
                           onClick={() => setActiveTab('statement')}
                           className={`
          px-6 py-2.5 rounded-lg font-semibold text-sm 
          transition-all duration-200 
          shadow-sm hover:shadow-md
          transform hover:scale-105 active:scale-95
          ${isDark
                                 ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white ring-1 ring-blue-500/50'
                                 : 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white shadow-blue-200'
                              }
        `}>
                           View Statement
                        </button>
                     )}
                     <button
                        onClick={onClose}
                        className={`
        px-6 py-2.5 rounded-lg font-medium text-sm 
        transition-all duration-200
        shadow-sm hover:shadow
        transform hover:scale-105 active:scale-95
        ${isDark
                              ? 'bg-slate-700/80 hover:bg-slate-600 text-slate-200 ring-1 ring-slate-600/50'
                              : 'bg-gray-100 hover:bg-gray-200 text-gray-700 ring-1 ring-gray-200'
                           }
      `}>
                        Cancel
                     </button>
                  </div>
               </div>
               {updateFormLoading && formData.id && (
                  <PaymentcaseFormEdit
                     isOutstandingModalOpen={isOutstandingModalOpen}
                     setIsOutstandingModalOpen={setIsOutstandingModalOpen}
                     daybookTypeData={daybookTypeData}
                     validationSchema={validationSchema}
                     isBankPageTrue={isBankPageTrue}
                     errors={errors}
                     setErrors={setErrors}
                     selectedAccount={selectedEditAccount}
                     setSelectedAccount={setSelectedEditAccount}
                     userData={accountData}
                     type={13}
                     isEditMode={true}
                     receivedAmount={receivedAmount}
                     setReceivedAmount={setReceivedAmount}
                     totalPendingAccount={totalPendingAccount}
                     setTotalPendingAccount={setTotalPendingAccount}
                     formData={formData}
                     setFormData={setFormData}
                     transactionType={transactionType}
                     handleClearData={handleClearData}
                     pendingVoucher={pendingVoucher}
                     setPendingVoucher={setPendingVoucher}
                     currentPage={1}
                     limit={10}
                     companyId={companyId}
                     sorting={sorting}
                     pagination={10}
                  />
               )}
               {(formType === 'Customer' || formType === 'Vendor') && (
                  <AddEditForm
                     isOpen={isOpen}
                     onClose={handleClose}
                     isEditMode={isEditMode}
                     currentRow={singleEntity}
                     initialData={singleEntity}
                     parentGlGroup={parentGlGroup}
                     formType={formType}
                  />
               )}
               {formType === 'Item' && (
                  <ItemMasterForm
                     isOpen={isOpen}
                     onClose={handleClose}
                     isEditMode={isEditMode}
                     currentRow={singleEntity}
                  />
               )}
               {formType === 'Account' && (
                  <AddEditFormForAccount
                     isOpen={isOpen}
                     onClose={handleClose}
                     isEditMode={isEditMode}
                     currentRow={singleEntity}
                     initialData={singleEntity}
                     formType={formType}
                  />
               )}
            </ModalContent>
         </Modal>
         {formType === 'daybook' && (
            <DaybookForm isOpen={isOpen} onClose={handleClose} isEditMode={isEditMode} currentRow={singleEntity} />
         )}
         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title={formType}
         />

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            title={
               entityTypesv === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityTypesv === 'salereturn'
                     ? 'Sales Return'
                     : entityTypesv === 'purchaseinvoice'
                        ? 'Purchase Invoice'
                        : entityTypesv === 'receiveinventory'
                           ? 'Receive Inventory'
                           : entityTypesv === 'issueinventory'
                              ? 'Issue Inventory'
                              : 'Purchase Return'
            }
            entityType={entityTypesv}
            singleEntity={viewDetail}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            // billTerms={viewDetail?.purchasereturnbillteams}
            billTerms={
               entityTypesv === 'saleinvoice'
                  ? viewDetail?.salebillterms
                  : entityTypesv === 'salereturn'
                     ? viewDetail?.salebillterms
                     : entityTypesv === 'purchaseinvoice'
                        ? viewDetail?.purchasebillteams
                        : entityTypesv === 'receiveinventory'
                           ? viewDetail?.receiveLineDetail
                           : entityTypesv === 'issueinventory'
                              ? viewDetail?.issueLineDetail
                              : viewDetail?.purchasereturnbillteams
            }
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityTypesv}
            singleEntity={singleEntitysv}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityTypesv === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <ViewSingleCashBankData
            isOpenSingleView={isOpenSingleViewcnb}
            onClose={() => setIsOpenSingleViewcnb(false)}
            singleEntity={singleEntitysv}
            formType="voucher"
            isBankPageTrue={isBankPageTrue}
            UserRights={cashRight}
            startEditing={(data) => startEditing(data.id, data)}
         />

         <JournalVoucherForm
            isOpen={isOpenJV}
            onClose={() => setisOpenJV(false)}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />
      </>
   );
};

export default ViewSingleData;
